import React, { useState, useEffect } from 'react'
import Axios from 'axios'
import './Registration.css';
import { host } from '../App';
import { UserOutlined, LogoutOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { Button, Menu, Dropdown, Modal } from 'antd';
import { Link } from "react-router-dom";

function Production_entry(props) {
  var token = (window.localStorage.getItem("acessToken"));
  const user = JSON.parse(window.localStorage.getItem("Name"));

  // declare all variables in order to send to js file
  var [shift, setShift] = useState("Morning Shift");
  var [Date1, setDate1] = useState(new Date());
  const [Date2, setDate2] = useState(Date1.toISOString().slice(0, 10));
  const [Morning_operators, setMorning_operators] = useState([]);
  const [Machine_list, setMachine_list] = useState([]);
  const [part_dataset, setpart_dataset] = useState([]);
  const [Night_operators, setNight_operators] = useState([]);
  const [Area, setArea] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // NEW: tracks which row indexes are missing a required field
  const [rowErrors, setRowErrors] = useState({});
  // NEW: controls the "review before submit" modal
  const [isReviewOpen, setIsReviewOpen] = useState(false);
  // NEW: holds the exact rows that will be sent to the server, shown inside the review modal
  const [reviewRows, setReviewRows] = useState([]);


  const [data, setData] = useState([
    { Date: Date2, Operator: '', Part_internalNo: '', PartNo: '', Customer: '', Part_description: '', Target: '', work_station: '', Produced: '', Scrap: '', Supervisor_notes: '', Operator_2: '' },
    { Date: Date2, Operator: '', Part_internalNo: '', PartNo: '', Customer: '', Part_description: '', Target: '', work_station: '', Produced: '', Scrap: '', Supervisor_notes: '', Operator_2: '' },
    { Date: Date2, Operator: '', Part_internalNo: '', PartNo: '', Customer: '', Part_description: '', Target: '', work_station: '', Produced: '', Scrap: '', Supervisor_notes: '', Operator_2: '' },
    { Date: Date2, Operator: '', Part_internalNo: '', PartNo: '', Customer: '', Part_description: '', Target: '', work_station: '', Produced: '', Scrap: '', Supervisor_notes: '', Operator_2: '' },
    { Date: Date2, Operator: '', Part_internalNo: '', PartNo: '', Customer: '', Part_description: '', Target: '', work_station: '', Produced: '', Scrap: '', Supervisor_notes: '', Operator_2: '' }
  ]);


  // Hook to update the date as today's date
  useEffect(() => {
    var timer = setInterval(() => setDate1(new Date()), 10)
    return function cleanup() {
      clearInterval(timer)
    }
  });



  useEffect(() => {
    Axios.get(`https://` + host + `/api/employees_all/${token}`).then((data) => {
      setMorning_operators(data.data);
      setNight_operators(data.data);
    });
  }, []);
  // to retreive Night operators
  // to retreive Machines
  useEffect(() => {
    Axios.get(`https://` + host + `/realapi/get/Machines/${token}`).then((data) => {
      setMachine_list(data.data)
    });
  }, [])
  // to retreive Machines
  useEffect(() => {
    Axios.get(`https://` + host + `/realapi/get/part_dataset/${token}`).then((data) => {
      setpart_dataset(data.data)

    });
  }, [])
  var Noperators = () => {
    Axios.get(`https://` + host + `/realapi/get/NightOperators/${token}`).then((data) => {
      setMorning_operators(data.data)
      setShift("Night Shift")

    });
  }
  // Retreive morning operators
  var Moperators = () => {
    Axios.get(`https://` + host + `/realapi/get/MorningOperators/${token}`).then((data) => {
      setMorning_operators(data.data)
      setShift("Morning Shift")
    });
  }
  // select rigid/flex or all parts
  const area = () => {

    if (Area == "Rigid") {
      console.log("rigid called");
      Axios.get(`https://` + host + `/realapi/get/Rigidpart_dataset/${token}`).then((data) => {
        setpart_dataset(data.data)
      });
      Axios.get(`https://` + host + `/realapi/get/RigidMachines/${token}`).then((data) => {
        setMachine_list(data.data)
      });
    }
    if (Area == "Flex") {
      Axios.get(`https://` + host + `/realapi/get/Flexpart_dataset/${token}`).then((data) => {
        setpart_dataset(data.data)
      });
      Axios.get(`https://` + host + `/realapi/get/FlexMachines/${token}`).then((data) => {
        setMachine_list(data.data)
      });
    }
    if (Area == "Others") {
      Axios.get(`https://` + host + `/realapi/get/part_dataset/${token}`).then((data) => {
        setpart_dataset(data.data)
      });
      Axios.get(`https://` + host + `/realapi/get/Machines/${token}`).then((data) => {
        setMachine_list(data.data)
      });
    }
  }


  useEffect(() => {
    const newData = data.map((line) => ({ ...line, Date: Date2 }));
    setData(newData);
  }, [Date2])

  // FIXED: this used to do part_dataset.find(...).Customer directly. If the typed value
  // didn't EXACTLY match a Part_internalNo in part_dataset (extra space, different case,
  // or free text that wasn't picked from the dropdown), .find() returned undefined and
  // .Customer on undefined threw — silently aborting before Customer/PartNo/Part_description
  // ever got set, even though Part_internalNo itself was already saved by onChange. That
  // left a row with a part number typed in but nothing else resolved, which then vanished
  // from the review popup because the submit filter requires Customer/PartNo/Description.
  // Now: match is trimmed + case-insensitive (same approach used in ManualSchedule.jsx),
  // it never throws, and a non-match explicitly clears the derived fields so validation
  // below can catch it and turn the row red instead of letting it disappear silently.
  const submitValue = (e, index) => {
    const typedValue = e.target.value.trim().replace(/\s+/g, ' ');
    const partDetails = part_dataset.find((x) =>
      x.Part_internalNo && x.Part_internalNo.trim().replace(/\s+/g, ' ').toLowerCase() === typedValue.toLowerCase()
    );

    const newData = [...data];
    newData[index] = { ...newData[index] };
    newData[index].Part_internalNo = e.target.value;

    if (partDetails) {
      newData[index].Customer = partDetails.Customer;
      newData[index].PartNo = partDetails.PartNo;
      newData[index].Part_description = partDetails.Part_description;
    } else {
      newData[index].Customer = '';
      newData[index].PartNo = '';
      newData[index].Part_description = '';
    }

    setData(newData);
  }

  const addLines = () => {
    if (data.length < 30) {
      const newData = [...data];
      for (let i = 0; i < 5; i++) {
        newData.push({ Date: Date2, Operator: data[0].Operator, Part_internalNo: '', PartNo: '', Customer: '', Part_description: '', Target: '', work_station: data[0].work_station, Produced: '', Scrap: '', Supervisor_notes: '', Operator_2: '' });
      }
      setData(newData);
    } else {
      window.alert("Lines Reached maximum limit")
    }

  }
  const handleLogout = () => {
    window.localStorage.removeItem("acessToken");
    window.localStorage.removeItem("Name");
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('user');
    props.history.push('/');
  }
  const userMenu = (
    <Menu>
      <Menu.Item key="logout">
        <a onClick={handleLogout} href="/">
          <LogoutOutlined />
          Logout
        </a>
      </Menu.Item>
    </Menu>
  );

  // NEW: Operator and Work Station can get auto-filled across every row the moment the
  // user types into row 0 (see the "index === 0" broadcast logic below) — that's a
  // convenience feature, not the user actually working on that row. So a row only
  // counts as "started" (and therefore worth validating) once it has something in a
  // field that is NOT part of that auto-fill broadcast: the selected Part, Target,
  // Produced, Scrap, Notes, or a second operator.
  const isRowStarted = (item) => {
    return !!(item.Part_internalNo || item.Target || item.Produced ||
      item.Scrap || item.Supervisor_notes || item.Operator_2);
  }

  // MODIFIED: required checkpoints are Operator, Work Station, Target, and Part
  // selection — same as before. NEW: if a Part_internalNo was typed but never resolved
  // to a real catalog entry (Customer/PartNo/Part_description still blank), that now
  // also counts as invalid, so the row turns red instead of silently dropping out of
  // the review popup at submit time.
  const isRowInvalid = (item) => {
    if (!isRowStarted(item)) return false;
    if (!item.Operator || !item.work_station || !item.Target || !item.Part_internalNo) return true;
    if (!item.PartNo || !item.Customer || !item.Part_description) return true;
    return false;
  }

  // NEW: walks every row, marks the invalid ones so they render red, returns whether the whole form is OK
  const validateRows = () => {
    const errors = {};
    let hasError = false;
    data.forEach((item, index) => {
      if (isRowInvalid(item)) {
        errors[index] = true;
        hasError = true;
      }
    });
    setRowErrors(errors);
    return !hasError;
  }

  // MODIFIED: builds a readable "what's missing" message for a given row, now including
  // the "typed but not recognized" case explicitly so it's obvious in the UI.
  const missingFieldsLabel = (item) => {
    const missing = [
      !item.Operator ? "Operator" : null,
      !item.work_station ? "Work Station" : null,
      !item.Target ? "Target" : null,
      !item.Part_internalNo ? "Part Selection" : null
    ].filter(Boolean);

    if (item.Part_internalNo && (!item.PartNo || !item.Customer || !item.Part_description)) {
      missing.push("Part Not Recognized — please reselect it from the dropdown list");
    }

    return missing.join(", ");
  }

  // MODIFIED: this used to fire the Axios POST directly. Now it validates the rows,
  // and if everything required is filled in, it opens a review modal instead of submitting straight away.
  const submitdata = () => {
    const formIsValid = validateRows();

    if (!formIsValid) {
      window.alert("Some rows are missing Operator, Work Station, Target or a valid selected Part. Those rows are highlighted in red — please complete or clear them before submitting.");
      return;
    }

    const rowsReadyToSubmit = data.filter(item =>
      item.Operator &&
      item.Part_internalNo &&
      item.PartNo &&
      item.Customer &&
      item.Part_description &&
      item.Produced
    );

    if (rowsReadyToSubmit.length === 0) {
      window.alert("There is nothing to submit yet. Please fill in at least one complete row.");
      return;
    }

    setReviewRows(rowsReadyToSubmit);
    setIsReviewOpen(true);
  }

  // NEW: this is what actually posts to the server, only called once the user confirms inside the review modal
  const confirmFinalSubmit = () => {
    const filteredData = reviewRows.map(item => ([
      item.Date,
      item.Operator,
      item.Part_internalNo,
      item.PartNo,
      item.Customer,
      item.Part_description,
      item.Target,
      item.work_station,
      item.Produced,
      item.Scrap,
      item.Supervisor_notes,
      item.Operator_2
    ]));

    setIsReviewOpen(false);
    setIsLoading(true);
    setTimeout(() => {
      Axios.post(`https://` + host + `/realapi/production_entry`, { filteredData, token })
        .then((response) => {
          if (response.status === 200) {
            window.alert(response.data.message);
            // window.localStorage.removeItem("data");
            setIsLoading(false);
            window.location.reload();

          }
        })
        .catch(error => {
          window.alert("Error Occured")
          setIsLoading(false);
        });
    }, 2000)
  }

  return (
    <div className="production-entry-page">
      <br></br>
      <div className="row">

        <div className="col-2">
          <div className="row">
            <div className="col">
              <label><b>
                <h4>Date</h4>
              </b></label>
              <input type="date" className="form-control form-rounded" placeholder="Date" name="Date" id='date' defaultValue={Date1.toISOString().slice(0, 10)} onChange={(e) => {
                setDate2(e.target.value)
              }} required />
            </div>
          </div>
        </div>

        <div className="col-1">
          <label><b>
            <h4> </h4>
          </b></label>
          <Link to="/openorder">
            <input type="button" className="btn btn-success" value="Open Orders" />
          </Link>
        </div>
        <div className="col-2">
          <label><b>
            <h4></h4>
          </b></label>
          <Link to="/Getreport">
            <input type="button" className="btn btn-success" value="Production Report" />
          </Link>
        </div>
        <div className="col-2">
          <Link to="/graph">
            <input type="button" className="btn btn-primary" value="Production Graph" />
          </Link>
        </div>
        <div className="col-2">

          <div className="top-bar">
            {/* Render the logo */}
            {/* Render the user dropdown */}
            <div className="user-dropdown">
              <Dropdown overlay={userMenu} trigger={['click']}>

                <Button icon={<UserOutlined />} size="large">
                  Welcome {user.replace(/[{""}]/g, "")}!
                </Button>
              </Dropdown>
            </div>
          </div>
        </div>
      </div>

      {/* MODIFIED: the old per-row Bootstrap col layout is replaced with an actual
          <table>. Same fields, same onChange handlers — just laid out in aligned
          columns with a sticky header instead of stacked divs. */}
      <div className="production-table-wrapper">
        <table className="production-entry-table">
          <thead>
            <tr>
              <th className="col-operator">Operator</th>
              <th className="col-area">Area</th>
              <th className="col-internal-part">Internal Part No</th>
              <th className="col-customer">Customer</th>
              <th className="col-partno">Part No</th>
              <th className="col-description">Description</th>
              <th className="col-target">Target</th>
              <th className="col-workstation">Work Station</th>
              <th className="col-produced">Produced</th>
              <th className="col-scrap">Scrap</th>
              <th className="col-operator2">Operator 2</th>
              <th className="col-notes">Supervisor Notes</th>
            </tr>
          </thead>
          <tbody>
            {data.map((line, index) => (
              <React.Fragment key={index}>
                <tr className={rowErrors[index] ? "production-row-invalid" : ""}>
                  <td className="col-operator">
                    <input
                      type="text"
                      className="form-control form-rounded"
                      onChange={(e) => {
                        const newData = [...data];
                        if (index === 0) {
                          for (let i = 0; i < newData.length; i++) {
                            newData[i].Operator = e.target.value;
                          }
                        }
                        else {
                          newData[index].Operator = e.target.value;
                        }
                        setData(newData);
                      }}
                      list="operatorList"
                      value={data[index].Operator}
                      placeholder="Operator"
                    />
                  </td>
                  <td className="col-area">
                    <select className="form-control form-rounded" placeholder="Area" onChange={(e) => {
                      setArea(e.target.value)
                    }} onClick={area} onKeyDown={area} name="area"
                    > <option value="Others">Others</option>
                      <option value="Flex">Flex</option>
                      <option value="Rigid">Rigid</option>
                    </select>
                  </td>
                  <td className="col-internal-part">
                    <input
                      type="text"
                      className="form-control form-rounded"
                      onChange={(e) => {
                        const newData = [...data];
                        newData[index].Part_internalNo = e.target.value;
                        setData(newData);
                      }}
                      onBlur={(e) => submitValue(e, index)} // Call the submitValue function on blur
                      list="InternalPartNo"
                      placeholder="Internal Part No"
                    />
                  </td>
                  <td className="col-customer">
                    <input
                      type="text"
                      className="form-control form-rounded"
                      value={data[index].Customer}
                      placeholder="Customer"
                      readOnly
                      required
                    />
                  </td>
                  <td className="col-partno">
                    <input
                      type="text"
                      className="form-control form-rounded"
                      value={data[index].PartNo}
                      placeholder="Part No"
                      readOnly
                    />
                  </td>
                  <td className="col-description">
                    <input
                      type="text"
                      className="form-control form-rounded"
                      value={data[index].Part_description}
                      readOnly
                      placeholder="Description"
                    />
                  </td>
                  <td className="col-target">
                    <input
                      type="text"
                      className="form-control form-rounded"
                      onChange={(e) => {
                        const newData = [...data];
                        newData[index].Target = e.target.value;
                        newData[index].Produced = e.target.value;
                        setData(newData);
                      }}
                      placeholder="Target"
                      name="target"
                      required
                    />
                  </td>
                  <td className="col-workstation">
                    <input
                      type="text"
                      className="form-control form-rounded"
                      onChange={(e) => {
                        const newData = [...data];
                        if (index === 0) {
                          for (let i = 0; i < newData.length; i++) {
                            newData[i].work_station = e.target.value;
                          }
                        }
                        else {
                          newData[index].work_station = e.target.value;
                        }
                        setData(newData);
                      }}
                      placeholder="Work Station"
                      value={data[index].work_station}
                      list="Work_station"
                    />
                  </td>
                  <td className="col-produced">
                    <input
                      type="text"
                      className="form-control form-rounded"
                      onChange={(e) => {
                        const newData = [...data];
                        newData[index].Produced = e.target.value;
                        setData(newData);
                      }}
                      placeholder="Produced"
                      name="produced"
                      value={data[index].Produced}
                      required
                    />
                  </td>
                  <td className="col-scrap">
                    <input
                      type="text"
                      className="form-control form-rounded"
                      onChange={(e) => {
                        const newData = [...data];
                        newData[index].Scrap = e.target.value;
                        setData(newData);
                      }}
                      placeholder="Scrap"
                      name="scrap"
                      required
                    />
                  </td>
                  <td className="col-operator2">
                    <input
                      type="text"
                      className="form-control form-rounded"
                      onChange={(e) => {
                        const newData = [...data];
                        newData[index].Operator_2 = e.target.value;
                        setData(newData);
                      }}
                      placeholder="Operator-2 (Optional)"
                      name="operator_2"
                      list="operatorList"
                      required
                    />
                  </td>
                  <td className="col-notes">
                    <textarea
                      className="form-control form-rounded"
                      onChange={(e) => {
                        const newData = [...data];
                        newData[index].Supervisor_notes = e.target.value;
                        setData(newData);
                      }}
                      placeholder="Supervisor Notes"
                      name="Supervisor_notes"
                    />
                  </td>
                </tr>
                {rowErrors[index] ? (
                  <tr className="production-row-error-tr">
                    <td colSpan={12}>
                      <ExclamationCircleOutlined /> Row {index + 1} is missing: {missingFieldsLabel(data[index])}
                    </td>
                  </tr>
                ) : null}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>

      {/* Shared datalists — kept once outside the table instead of re-rendered per row */}
      <datalist id="operatorList">
        <option></option>
        {Morning_operators.map(x => {
          return <option key={x.Name}>{x.Name}</option>
        })}
      </datalist>
      <datalist id="InternalPartNo">
        <option></option>
        {part_dataset.map((x) => {
          return <option key={x.Part_internalNo}>{x.Part_internalNo}</option>;
        })}
      </datalist>
      <datalist id="Work_station">
        <option></option>
        {Machine_list.map(x => {
          return <option key={x.Machines}>{x.Machines}</option>
        })}
      </datalist>

      <div className="production-actions">
        <button onClick={submitdata} className="btn btn-primary">Submit</button>
        <button onClick={addLines} className="btn btn-success">Add Row</button>
        <Link to="/RetrieveData">
          <button type="button" className="btn btn-success" >Read Table </button>
        </Link>
        <Link to="/Scheduling">
          <button type="button" className="btn btn-secondary" >Scheduling </button>
        </Link>
      </div>

      {/* Review-before-submit modal. Shows exactly what will be sent to the server. */}
      <Modal
        title="Review Production Entries Before Submitting"
        open={isReviewOpen}
        onCancel={() => setIsReviewOpen(false)}
        width="85vw"
        centered
        footer={[
          <Button key="back" onClick={() => setIsReviewOpen(false)}>
            Go Back &amp; Edit
          </Button>,
          <Button key="submit" type="primary" onClick={confirmFinalSubmit}>
            Confirm &amp; Submit
          </Button>
        ]}
        className="production-review-modal"
      >
        <p className="production-review-subtitle">
          {reviewRows.length} row{reviewRows.length !== 1 ? "s" : ""} will be submitted. Please review before confirming.
        </p>
        <div className="production-review-table-wrapper">
          <table className="production-review-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Date</th>
                <th>Operator</th>
                <th>Internal Part No</th>
                <th>Target</th>
                <th>Work Station</th>
                <th>Produced</th>
                <th>Scrap</th>
                <th>Operator 2</th>
                <th>Supervisor Notes</th>
              </tr>
            </thead>
            <tbody>
              {reviewRows.map((item, i) => (
                <tr key={i}>
                  <td>{i + 1}</td>
                  <td>{item.Date}</td>
                  <td>{item.Operator}</td>
                  <td>{item.Part_internalNo}</td>
                  <td>{item.Target}</td>
                  <td>{item.work_station}</td>
                  <td>{item.Produced}</td>
                  <td>{item.Scrap}</td>
                  <td>{item.Operator_2}</td>

                  <td>{item.Supervisor_notes}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Modal>

      {isLoading ?
        <div className='overlay'>
          <div className="text-center">
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </div> : null}
    </div>
  )
}

export default Production_entry